module.exports = __webpack_public_path__ + "static/media/test14_4.ece5a38d.png";